module.exports = __webpack_public_path__ + "img/doc-sync.fcd6c233.svg";